import VueRouter from 'vue-router';
import { empty } from 'views/components/php.js';

Vue.use(VueRouter);

function esta_autenticado() {
  let local_s = localStorage.getItem('usuario');
  if (local_s === null) {
    return false;
  }
  local_s = JSON.parse(local_s);
  if (empty(local_s.id)) {
    return false;
  }
  if (empty(local_s.token)) {
    return false;
  }
  if (empty(local_s.clave)) {
    return false;
  }
  if (empty(local_s.usuario)) {
    return false;
  }

  return true;
}

function guardian_ruta(to, from, next) {
  const estaautenticado = esta_autenticado();

  if (is_app) {
    if (to.path !== '/login' && estaautenticado === false) next('/login');
    else {
      next();
    }
  } else if (estaautenticado === true && to.path === '/login') {
    next('/');
  } else if (estaautenticado === true && to.path !== '/login') {
    next();
  } else if (estaautenticado === false && to.path !== '/login') {
    next();
  } else if (estaautenticado === false && to.path === '/login') {
    next();
  }
}

export default new VueRouter({
  base: 'pro',
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/login',
      component: () => import('views/components/mm_pro/views/login.vue'),
      beforeEnter: guardian_ruta,
    },
    {
      path: '/',
      component: () => import('views/components/mm_pro/empresa/dashboard.vue'),
      beforeEnter: guardian_ruta,
    },
    {
      path: '/perfil/:subseccion?',
      component: () =>
        import('views/components/mm_pro/empresa/perfil/perfil_empresa.vue'),
      beforeEnter: guardian_ruta,
    },
    {
      path: '/comprar',
      component: () =>
        import(
          'views/components/mm_pro/empresa/solicitudes_por_comprar/solicitudes_por_comprar.vue'
        ),
      beforeEnter: guardian_ruta,
    },
    {
      path: '/cotizar',
      component: () =>
        import('views/components/mm_pro/empresa/lista_solicitudes/lista_solicitudes.vue'),
      props: {
        titulo_seccion: 'solicitudes por cotizar',
        uri: 'crm_dir/pro_cotizacion/get_solicitudes_por_cotizar',
      },
      beforeEnter: guardian_ruta,
    },
    {
      path: '/participando',
      component: () =>
        import('views/components/mm_pro/empresa/lista_solicitudes/lista_solicitudes.vue'),
      props: {
        titulo_seccion: 'solicitudes en seguimiento',
        uri: 'crm_dir/pro_contrato/get_solicitudes_por_confirmar',
      },
      beforeEnter: guardian_ruta,
    },
    {
      path: '/agendados',
      component: () => import('views/components/mm_pro/empresa/contratado/index.vue'),
      beforeEnter: guardian_ruta,
    },
    {
      path: '/cotizacion/:id_mm',
      component: () => import('views/components/mm_pro/empresa/cotizacion/index.vue'),
      beforeEnter: guardian_ruta,
      props: true,
    },
    {
      path: '/editar_solicitud/:id_mm',
      component: () =>
        import(
          'views/components/mm_pro/empresa/cotizacion/detalles/modificacion_solicitud.vue'
        ),
      beforeEnter: guardian_ruta,
      props: true,
    },
    {
      path: '/estadisticas',
      component: () => import('views/pro/estadisticas/tabla_consumo.vue'),
      beforeEnter: guardian_ruta,
    },
    {
      path: '/calificaciones',
      component: () => import('views/components/mm_pro/empresa/calificaciones/index.vue'),
      beforeEnter: guardian_ruta,
    },
    {
      path: '/facturacion',
      component: () => import('views/components/mm_pro/empresa/facturacion/index.vue'),
      beforeEnter: guardian_ruta,
    },
    {
      path: '/cambiar_contrasena',
      component: () => import('@frontend/account/views/cambiar_contrasena.vue'),
      props: (route) => ({
        token: route.query.token,
        id: route.query.id,
        modulo: route.query.modulo,
      }),
      beforeEnter: guardian_ruta,
    },
    {
      path: '/configurar_alertas_trabajo',
      component: () => import('views/components/mm_pro/empresa/alertas/index.vue'),
      beforeEnter: guardian_ruta,
    },
    {
      path: '/calendario_llamada',
      component: () =>
        import(
          'views/components/mm_pro/empresa/herramientas_venta/calendario_llamadas_agendadas.vue'
        ),
      beforeEnter: guardian_ruta,
    },
    {
      path: '/buscador',
      name: 'buscador',
      component: () =>
        import(
          'views/components/mm_pro/empresa/lista_solicitudes/resultados_busqueda.vue'
        ),
      beforeEnter: guardian_ruta,
    },
    {
      path: '/papelera',
      name: 'papelera',
      component: () =>
        import(
          'views/components/mm_pro/empresa/lista_solicitudes/solicitudes_archivadas.vue'
        ),
      beforeEnter: guardian_ruta,
    },
  ],
});
